module.exports = __webpack_public_path__ + "src/assets/img/guy_right_4.30afe457.png";